module.exports = __webpack_public_path__ + "static/media/footer-image.eaba79e8.png";